import { Injectable } from '@angular/core'
import { BuilderService } from '../../builder-services/builder.service'
import { HelpersService } from '../../helpers.service'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { UsersApiService } from 'src/app/builder-services/api/users.api.service'
import { Observable, from } from 'rxjs'
import { MatTableDataSource } from '@angular/material/table'

@Injectable({
  providedIn: 'root'
})
export class AppUsersService {
  private builderUrl: string
  token: any
  users: any; 
  usersDataSource = new MatTableDataSource<any>([]);
  options = {
    headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
  }
  constructor(
    private builderService: BuilderService,
    private helper: HelpersService,
    private http: HttpClient,
    private usersApi: UsersApiService
  ) {
    this.builderUrl = this.helper.getBuilderUrl()
  }

  /**
   * Get all the users of the Customer website
   * @param id the Project ID
   */
  getUsersCount = (): Observable<number> => {
    return from(this.usersApi.getUsersCount(this.builderService.selectedProject))
  }

  /**
   * All project users, straight from the API.
   *
   * Deliberately separate from getUsers(): that one branches on `standalone`
   * and falls back to the WordPress endpoint, while callers of this one (the
   * points screens) have always read from the API unconditionally.
   */
  /**
   * Records the caller's own last login, optionally raising their projects limit.
   * The account is taken from the JWT server-side — nothing is passed from here.
   */
  updateUserLastLogin = (projectsLimit?: number | 'unlimited'): Promise<void> => {
    return this.usersApi.updateUserLastLogin(projectsLimit)
  }

  getProjectUsers = (): Promise<any[]> => {
    return this.usersApi.getUsers(this.builderService.selectedProject)
  }

  getUsers = (id: any) => {
    if (this.builderService.standalone) {
      return from(this.usersApi.getUsers(this.builderService.selectedProject))
    } else {
      this.token = this.builderService.getToken()
      let postData = new URLSearchParams()
      postData.set('token', this.token)
      postData.set('projectId', id)
      return this.http.post(this.builderUrl + 'get-users', postData.toString(), this.options)
    }
  }
  /**
   * Get all the users of the same project
   * @param projectId
   */
  getUsersByProjectId = (projectId: any): Observable<any> => {
    this.token = this.builderService.getToken()
    let postData = new URLSearchParams()
    postData.set('token', this.token)
    postData.set('projectId', projectId)
    return this.http.post(this.builderUrl + 'get-users-of-same-project', postData.toString(), this.options)
  }

  /**
     * Retrieves a specific user .
     * @param id - The Project ID.
     * @param userId - The User ID.
     * @returns An Observable that emits the user data.
     * If the application is in standalone mode, it retrieves the user data from the local database.
     * Otherwise, it sends a POST request to the backend API to fetch the user data.

     */
  getUser = (id: any, userId: any) => {
    if (this.builderService.standalone) {
      return from(this.usersApi.getUser(this.builderService.selectedProject, userId))
    } else {
      this.token = this.builderService.getToken()
      let postData = new URLSearchParams()
      postData.set('token', this.token)
      postData.set('projectId', id)
      return this.http.post(this.builderUrl + 'get-users', postData.toString(), this.options)
    }
  }

  /**
   * Removes a user from the specified project in the database.
   * @param user_id - The ID of the user to be removed.
   * @returns An Observable that emits an empty object upon successful removal of the user.
   * The Observable completes after the operation, regardless of success or failure.
   */
  removeUser = (user_id: string) => {
    const project_id = this.builderService.selectedProject
    return from(this.usersApi.removeUser(project_id, user_id))
  }
  
   /**
   * saves the user in the database in the same project 
   * @param user 
   * @returns 
   */

   saveUser(user: any): Observable<any> {
    const projectId = this.builderService.selectedProject

    if (!projectId) {
      console.error('No project selected!')
    }

    let postData = new URLSearchParams()
    postData.set('email', user.emailAddress)
    postData.set('password', user.password)
    postData.set('firstname', user.firstName)
    postData.set('lastname', user.lastName)
    postData.set('phone_number', user.phoneNumber)
    postData.set('type', 'client')
    postData.set('role', user.selectedRole)
    postData.set('projectId', projectId)

    return this.http.post(this.builderUrl + 'create_user_in_project', postData.toString(), this.options)
  }

  /**
   * Get a specific WP user by meta 'user_id'
   */
  getStacksUser(userId: string): Observable<any> {
    this.token = this.builderService.getToken()
    let postData = new URLSearchParams()
    postData.set('token', this.token)
    postData.set('user_id', userId)
    return this.http.post(this.builderUrl + 'get-user-by-id', postData.toString(), this.options)
  }

  updateUser(projectId: string, userId: string, user: any): Observable<any> {
    return from(this.usersApi.updateUser(projectId, userId, user))
  }


  /**
   * Update user role
   */

  updateUserRole = (userId: string, new_role: string): Observable<any> => {
    this.token = this.builderService.getToken()
    let postData = new URLSearchParams()
    postData.set('token', this.token)
    postData.set('user_id', userId)
    postData.set('new_role', new_role)
    return this.http.post(this.builderUrl + 'update_user_role', postData.toString(), this.options)
  }
  deleteStacksUser = (userId: string): Observable<any> => {
    this.token = this.builderService.getToken()
    let postData = new URLSearchParams()
    postData.set('token', this.token)
    postData.set('user_id', userId)
    return this.http.post(this.builderUrl + 'delete_user', postData.toString(), this.options)
  }
 
}
